/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement } from 'react';
import { Carousel } from 'react-responsive-carousel';
import './MatchedVisasDashboard-Mobile-experiment-1.scss';

type Testimonial = {
    id: number;
    name: string;
    content: string;
    date: Date;
};

const testimonials: Testimonial[] = [
    {
        id: 1,
        name: 'Hannah Schmitt',
        content:
            '"Thanks to Aliro, my journey to obtaining a Canadian visa was as seamless as ordering an Uber. Their visa expert made the process simple and stress-free."',
        date: new Date(),
    },
];

type SingleTestimonialProps = {
    key: number;
    name: string;
    content: string;
    date: Date;
};

function SingleTestimonial({
    key,
    name,
    content,
    date,
}: SingleTestimonialProps): ReactElement | null {
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return (
        <div className="TestimonialSection">
            <div className="Testimonial" style={{ marginTop: '1rem' }}>
                <div className="Title">{name}</div>
                <div className="TestimonialContent">{content}</div>
                <div className="Date">{`${month} ${day}, ${year}`}</div>
            </div>
        </div>
    );
}

export default function CustomerTestimonials(): ReactElement | null {
    const testimonialsForCarousel = testimonials.map((item: any) => (
        <SingleTestimonial key={item.id} name={item.name} content={item.content} date={item.date} />
    ));
    return (
        <div className="TestimonialsSection">
            <div className="Header2">
                <span className="Title">Customer Testimonials</span>
            </div>
            <span className="carouselSection">
                <div className="MatchedVisasBody">
                    <Carousel
                        className="carrousel carrouselMobile"
                        infiniteLoop={true}
                        autoPlay={false}
                        showStatus={false}
                        // showArrows={false}
                        interval={5000}
                        centerMode={true}
                        showThumbs={false}
                        // selectedItem={2}
                        centerSlidePercentage={100}
                    >
                        {testimonialsForCarousel}
                    </Carousel>
                </div>
            </span>
        </div>
    );
}
